<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="labour_name" [ttModel]="edit.labour_name" ttReadonly></tt-input>
        <tt-input ttLabel="salarytype_name" [ttModel]="edit.salarytype_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="salary_rate" [(ttModel)]="edit.salary_rate" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="calc_cost_rate" [(ttModel)]="edit.calc_cost_rate" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-button-save ttText="laboursalarytype_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
